import React from 'react';
import PropTypes from 'prop-types';
import { t, Trans } from '@lingui/macro';
import { Flex, P, RadioGroup, TextField } from '@decisiv/ui-components';

export default function MetadataFilter({
  handleForm,
  currentValue,
  currentMetadataKey = '',
  currentMetadataValue = '',
}) {
  return (
    <>
      <P marginBottom={1}>
        <Trans>Metadata</Trans>
      </P>
      <RadioGroup
        marginBottom={1}
        name="radio_metadata"
        items={[
          { label: t`Both`, value: 'Both' },
          { label: t`With Metadata`, value: 'With Metadata' },
          { label: t`Without Metadata`, value: 'Without Metadata' },
        ]}
        vertical
        value={currentValue}
        onChange={(e) => {
          handleForm({ event: e, field: 'metadata' });
        }}
      />
      {currentValue !== 'Without Metadata' && (
        <Flex flexDirection="column" marginTop={1}>
          <TextField
            label={t`Key`}
            name="metadataKey"
            value={currentMetadataKey || ''}
            onChange={(e) => {
              handleForm({ event: e, field: 'metadataKey' });
            }}
          />
          <Flex marginTop={1}>
            <TextField
              label={t`Value`}
              name="metadataValue"
              value={currentMetadataValue || ''}
              onChange={(e) => {
                handleForm({ event: e, field: 'metadataValue' });
              }}
            />
          </Flex>
        </Flex>
      )}
    </>
  );
}

MetadataFilter.propTypes = {
  handleForm: PropTypes.func.isRequired,
  currentValue: PropTypes.string.isRequired,
  currentMetadataKey: PropTypes.string,
  currentMetadataValue: PropTypes.string,
};
